import { ErrorsType } from 'interfaces';
import { useSigninMutation } from 'interfaces/graphql.types';
import { useAuth } from 'modules/auth/providers/AuthProvider';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { formatError, setSentryErrors } from 'utils/helpers/errorHandler';

export const useSignIn = () => {
  const [errors, setErrors] = useState<ErrorsType>(null);
  const [signIn, { loading: signInLoading }] = useSigninMutation();
  const {
    login,
    state: { loading: loginLoading },
  } = useAuth();

  const router = useRouter();

  const resetErrors = (code: number) =>
    setErrors((errors) => errors?.filter((error) => error.code !== code));

  const onSubmit = useCallback(
    async (values) => {
      try {
        const result = await signIn({
          variables: { data: values },
        });

        if (result.data?.login.success) {
          setErrors(null);
          if (result.data?.login.userId) {
            await login({ userId: result.data.login.userId });
          } else {
            const matches = router.asPath.match(/to=([^&]*)/);
            router.push({
              pathname: '/auth/2-fa',
              query: { from: '/auth/signin', to: matches?.[1] },
            });
          }
        } else {
          const errors = result.data?.login.errors;
          setErrors(errors);
          setSentryErrors(errors, { userId: result.data?.login.userId || '' });
        }
      } catch (e) {
        const formattedError = formatError(e);
        setErrors([formattedError]);
        setSentryErrors(e);
      }
    },
    [signIn, login, router]
  );

  return {
    loading: Boolean(signInLoading || loginLoading),
    errors,
    onSubmit,
    resetErrors,
  };
};
